// extracted by mini-css-extract-plugin
export var generalContent = "GeneralContent-module--general-content--2cjms";